/**
 * ObjectUtil.ts
 */
export class ObjectUtil {
    /**
     * Could be replaced by Reflect.create.
     */
    static create(type, ...args) {
        return new type(...args);
    }
    /**
     * take the param names from propObj, overWrite target with the values of the named params in source
     * Could be replaced by Object.apply.
     */
    static overwriteProperties(target, source, propObj) {
        for (let prop in propObj) {
            if (Array.isArray(source[prop])) {
                target[prop] = source[prop].slice();
            }
            else {
                target[prop] = source[prop];
            }
        }
    }
}
//# sourceMappingURL=ObjectUtil.js.map